module.exports = __webpack_public_path__ + "static/img/e.f784e5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/e.png
// module id = D9rm
// module chunks = 0